import { render } from "./post-project.vue?vue&type=template&id=7ac121ad"
import script from "./post-project.vue?vue&type=script&lang=js"
export * from "./post-project.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__